/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateCompanyDto
 */
export interface CreateCompanyDto {
    /**
     * Company name
     * @type {string}
     * @memberof CreateCompanyDto
     */
    name: string;
    /**
     * URL or identifier for company logo
     * @type {string}
     * @memberof CreateCompanyDto
     */
    logo?: string;
}

/**
 * Check if a given object implements the CreateCompanyDto interface.
 */
export function instanceOfCreateCompanyDto(value: object): value is CreateCompanyDto {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function CreateCompanyDtoFromJSON(json: any): CreateCompanyDto {
    return CreateCompanyDtoFromJSONTyped(json, false);
}

export function CreateCompanyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCompanyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'logo': json['logo'] == null ? undefined : json['logo'],
    };
}

export function CreateCompanyDtoToJSON(json: any): CreateCompanyDto {
    return CreateCompanyDtoToJSONTyped(json, false);
}

export function CreateCompanyDtoToJSONTyped(value?: CreateCompanyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'logo': value['logo'],
    };
}

